import { c as _c } from "react/compiler-runtime";
import { ProgressOverviewSectionItem } from "@components/progress-overview/progress-overview-section-item";
import { useUploadTasks } from "@hooks/upload-tasks/use-upload-tasks";
import { Box } from "@mui-wrapper";

/** Renders the progress section inside the progress overview menu */
export function ProgressOverviewSection() {
  const $ = _c(8);
  const {
    failedTasks,
    inProgressTasks
  } = useUploadTasks();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      overflow: "auto"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== failedTasks) {
    t1 = !!failedTasks.length && <ProgressOverviewSectionItem tasks={failedTasks} label="Failed" />;
    $[1] = failedTasks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== inProgressTasks) {
    t2 = !!inProgressTasks.length && <ProgressOverviewSectionItem tasks={inProgressTasks} label="In progress" />;
    $[3] = inProgressTasks;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Box sx={t0}>{t1}{t2}</Box>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}